export const API_HOST = process.env.REACT_APP_BASE_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const S3_IMAGE_BASE_URL = process.env.REACT_APP_S3_IMAGE_BASE_URL;
